import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { MicroserviceTypes } from 'typings';
import { useOrderByIdQuery } from 'api';

export const OrderAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  const { data: { isFinalStatus } = {} } = useOrderByIdQuery({ id }, { skip: !id });
  return (
    <Attachments
      entityId={id}
      entityName={'ORDER'}
      service={'wrd' as MicroserviceTypes}
      hasAccessToWrite={hasAccess(PERMISSIONS.orders.attachment.write) && !isFinalStatus}
      hasAccessToDelete={hasAccess(PERMISSIONS.orders.attachment.delete) && !isFinalStatus}
    />
  );
});
